import {Injectable} from '@angular/core';
import {ApiService, GetListResponse, ModelBase} from '@app/api/api.service';

export interface User extends ModelBase {
    full_name: string;
    email: string;
    customer_id: number;
    is_superuser: boolean;
    user_prefs: {};
    user_privileges: {};
    user_roles: {};
}

interface GetUsersArguments {
    customerId: number;
    offset: number;
    limit: number;
}

interface GetUsersResponse extends GetListResponse {

    users: User[];
}

@Injectable({
    providedIn: 'root'
})

export class UserApiService {

    constructor(private apiService: ApiService) {
    }


    public async getUsers(args: GetUsersArguments): Promise<GetUsersResponse> {
        const {customerId, offset, limit} = args;
        return await this.apiService.getResponseJson(
            {
                urlPart: '/users',
                method: 'GET',
                queryStringParams: {
                    customer_id: customerId,
                    offset: offset,
                    limit: limit
                }
            });
    }

    public async getUsersByIds(user_ids: number[]): Promise<GetUsersResponse> {
        return await this.apiService.getResponseJson(
            {
                urlPart: '/users',
                method: 'GET',
                queryStringParams: {
                    user_ids: user_ids
                }
            });
    }

    public async deleteUser(args: { user: User }): Promise<{ user: User }> {
        const {user} = args;
        return await this.apiService.getResponseJson(
            {
                urlPart: `/users/${user.id}`,
                method: 'DELETE'

            });
    }

    public async createUser(args: { user: User }): Promise<{ user: User }> {
        const {user} = args;
        return await this.apiService.getResponseJson({
            urlPart: '/users/new',
            method: 'POST',
            data: user
        });
    }

    public async updateUser(args: { user: User }): Promise<{ user: User }> {
        const {user} = args;
        return await this.apiService.getResponseJson({
            urlPart: `/users/${user.id}`,
            method: 'PUT',
            data: user
        });
    }

    public async resetUserPassword(
        args: { userId: number }
    ): Promise<{ message: string }> {
        const {userId} = args;
        return this.apiService.getResponseJson({
            urlPart: `/users/${userId}/reset-password`,
            method: 'POST'
        });
    }

    public async getAuthenticatedUser(): Promise<{ user: User }> {
        return this.apiService.getResponseJson({
            urlPart: '/users/me',
            method: 'GET'
        });
    }
}

